import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import { colors } from '../../constants/styleConstants';

const EditFbIcon = ({ color, className }) => <EditIcon className={className} style={{ fill: color }} />;

EditFbIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

EditFbIcon.defaultProps = {
  color: colors.blue,
  className: '',
};

export default EditFbIcon;
